import { T as Tooltip, d as defineCustomElement$1 } from './tooltip.js';

const TtTooltip = Tooltip;
const defineCustomElement = defineCustomElement$1;

export { TtTooltip, defineCustomElement };
